<template>
  <div class="container" @click.stop @mouseover.stop="onMouseOver">
    <div class="rights-only" v-if="rightsOnly">
      <span>解锁导出{{tabs[1].name === 'rights' && rightsNumber ? `(${rightsNumber})` : ''}}</span>
      <i class="icon-close" @click="close"></i>
    </div>
    <div class="tabs" v-else>
      <div
        class="tab"
        :class="{active: tab.name === activeTab}"
        v-for="tab, i in tabs"
        :key="i"
        @click="activateTab(tab.name)"
      >
        {{tab.text}}{{tab.name === 'rights' && rightsNumber ? `(${rightsNumber})` : ''}}
      </div>
    </div>
    <div class="content" ref="contentRef" :class="{'active-rights': activeTab === 'rights'}">
      <rights v-if="activeTab === 'rights'" :type="type"></rights>
      <Commercial v-if="activeTab === 'commercial'"></Commercial>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Rights from './riskDrop/rights';
import Commercial from './riskDrop/commercial.vue';
import { getVipList as getVipSceneEffects } from './riskDrop/sceneEffectTypes.js';
// import a from '../../../static/svg'
export default {
  components: {
    Rights,
    Commercial
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tabs: [
        {name: 'commercial', text: '商用权限'},
        {name: 'rights', text: '使用权限'}
      ],
      activeTab: 'commercial',
      rightsNumber: 0,
      rightsOnly: false
    }
  },
  computed: {
    ...mapGetters([
      'IsVipSprites',
      'TOOL',
      'UserEquity',
      'UserMsg'
    ])
  },
  watch: {
    "IsVipSprites.data" (val = []) {
      this.getRightsNumber(val);
    },
  },
  created () {
    this.getRightsNumber(this.IsVipSprites.data);
    this.$bus.on('riskDropShow', this.riskDropShow);
    eve.on('scene.effectUpdated', () => {
      this.getRightsNumber(this.IsVipSprites.data);
    });
  },
  mounted () {
    let rect = this.$el.getBoundingClientRect();
  },
  methods: {
    onMouseOver () {
      this.$emit('mouseOver');
    },
    close () {
      this.$emit('close');
    },
    activateTab (name) {
      this.rightsOnly = false;
      this.activeTab = name;
    },
    onRightsNumber (n) {
      this.rightsNumber = n;
    },
    getRightsNumber (list) {
      if (this.UserMsg.payForFont == 1) {
        list = list.filter(v => v.fileType != 15);
      }
      if (this.UserMsg.payForMaterial == 1) {
        list = list.filter(v => v.fileType == 15);
      }
      let videoData = list.find(v => v.videoNum && v.sprites);
      let listLen = list.length;
      if (videoData && videoData.sprites) {
        let videoNum = videoData.sprites.length;
        let _vn = videoData.videoNum;
        let _dn = this.UserEquity.draftVideo;
        if (_vn > 3) {
          _dn = 3;
        }
        let overSize = videoNum - _dn;
        listLen = listLen - 1 + overSize;
      }
      const sceneEffectCount = getVipSceneEffects(this.TOOL.sprites).length;
      listLen += sceneEffectCount;
      this.rightsNumber = listLen;
    },
    riskDropShow () {
      let el = this.$refs.contentRef;
      if (!el) {
        return;
      }
      let rect = el.getBoundingClientRect();
      let h = window.innerHeight - rect.top - 20;
      el.style.maxHeight = h + 'px';
      el.style.overflow = 'auto';
    },
    setRightsOnly (flag) {
      this.rightsOnly = flag;
      if (flag) {
        this.activeTab = 'rights';
      } else {
        this.activeTab = 'commercial';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 360px;
  // min-height: 307px;
  margin-top: 5px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
}
.rights-only {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 56px;
  font-weight: bold;
  color: #2F58FE;
  padding-left: 20px;
  padding-right: 16px;
  cursor: pointer;
  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translatex(-50%);
    content: ' ';
    height: 1px;
    width: 320px;
    background: #E6E6E6;
  }
}
.tabs {
  position: relative;
  display: flex;
  justify-content: center;
  height: 56px;
  &::before {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translatex(-50%);
    content: ' ';
    width: 1px;
    height: 100%;
    background: #E6E6E6;
  }
  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translatex(-50%);
    content: ' ';
    height: 1px;
    width: 320px;
    background: #E6E6E6;
  }
}
.tab {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  &.active {
    font-weight: bold;
    color: #2F58FE;
  }
}
.content {
  &.active-rights {
    border-bottom: 40px transparent solid;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #D8DEE9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
.icon-close {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: no-repeat;
  background-image: url(../../../static/svg/close.svg);
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop.vue